<div class="container">
  <social-icons></social-icons>

  <div class="footer-text__container">
    <span class="footer-text" #typedFooter></span>
  </div>
</div>
